import styled from 'styled-components'

export const BareButton = styled.button<{ disabled?: boolean }>`
  border: none;
  background: none;
  padding: 6px;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'default')};
  transform: translateY(1px);
`
